import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ContactService } from '../service/contact.service';
import * as contactActions from '../action/contact.action';
import { catchError, exhaustMap } from 'rxjs/operators';
import { map, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ContactResponseModel } from '../model/contact-response.model';



@Injectable()
export class ContactEffect {
  contact$ = createEffect(() => this.actions$.pipe(
    ofType(contactActions.contact),
    exhaustMap(action => this.contactService.sendEmail(
      action.name,
      action.email,
      action.message,
      action.captcha
    ).pipe(
      map(response => contactActions.contactSuccess(response)),
      catchError((error: HttpErrorResponse) => {
        return of(contactActions.contactFailure((<ContactResponseModel>error.error)));
      })
    )))
  )

  constructor(
    private actions$: Actions,
    private contactService: ContactService
  ) { }
}
